import { Alert, AlertDescription, AlertTitle } from "@coval/ui/alert"
import { Button } from "@coval/ui/button"
import { Card, CardContent } from "@coval/ui/card"
import { Skeleton } from "@coval/ui/skeleton"

export function OverageSettingsVerification({
  failed,
  onRetry,
}: {
  failed: boolean
  onRetry: () => void
}) {
  return (
    <Card>
      <CardContent className="p-6">
        {failed ? (
          <Alert variant="danger">
            <AlertTitle>Couldn't load overage settings</AlertTitle>
            <AlertDescription>
              Check that you have access to this organization and try again. No
              settings have been changed.
            </AlertDescription>
            <Button variant="secondary" className="mt-3" onClick={onRetry}>
              Try again
            </Button>
          </Alert>
        ) : (
          <div role="status" aria-label="Loading overage settings">
            <Skeleton className="h-24 w-full" />
          </div>
        )}
      </CardContent>
    </Card>
  )
}
